module.exports = __webpack_public_path__ + "img/sub.bc1021f1.png";